import React, { useCallback, useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const BASIS = {
  4: "basis-[86%] sm:basis-[48%] lg:basis-[calc(25%-18px)]",
  3: "basis-[86%] sm:basis-[48%] lg:basis-[calc(33.333%-16px)]",
};

export const CardCarousel = ({ children, perView = 4, testid = "carousel" }) => {
  const ref = useRef(null);
  const [edges, setEdges] = useState({ start: true, end: false });

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setEdges({
      start: el.scrollLeft <= 8,
      end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 8,
    });
  }, []);

  useEffect(() => {
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [update, children]);

  const scrollBy = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: "smooth" });
  };

  const items = React.Children.toArray(children);
  const overflow = items.length > perView;

  return (
    <div className="relative" data-testid={testid}>
      <div ref={ref} onScroll={update} data-testid={`${testid}-track`}
        className="flex gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-2 -mx-4 px-4 sm:mx-0 sm:px-0 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
        {items.map((child, i) => (
          <div key={child.key || i} className={`snap-start shrink-0 grow-0 ${BASIS[perView] || BASIS[4]}`}>
            {child}
          </div>
        ))}
      </div>

      {overflow && (
        <>
          <button type="button" onClick={() => scrollBy(-1)} disabled={edges.start}
            aria-label="Anterior" data-testid={`${testid}-prev`}
            tabIndex={edges.start ? -1 : 0} aria-hidden={edges.start}
            className="hidden lg:flex absolute -left-5 top-1/2 -translate-y-1/2 h-11 w-11 items-center justify-center rounded-full bg-white border border-[#E2DFD7] text-[#16221D] shadow-[0_10px_30px_rgb(0,0,0,0.12)] transition-opacity duration-300 disabled:opacity-0 hover:bg-[#16221D] hover:text-white hover:border-[#16221D]">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button type="button" onClick={() => scrollBy(1)} disabled={edges.end}
            aria-label="Siguiente" data-testid={`${testid}-next`}
            tabIndex={edges.end ? -1 : 0} aria-hidden={edges.end}
            className="hidden lg:flex absolute -right-5 top-1/2 -translate-y-1/2 h-11 w-11 items-center justify-center rounded-full bg-white border border-[#E2DFD7] text-[#16221D] shadow-[0_10px_30px_rgb(0,0,0,0.12)] transition-opacity duration-300 disabled:opacity-0 hover:bg-[#16221D] hover:text-white hover:border-[#16221D]">
            <ChevronRight className="h-5 w-5" />
          </button>
        </>
      )}
    </div>
  );
};
